import React from 'react';

// SVG logos from cdn.simpleicons.org
const LOGO_URLS = {
  slack: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/slack.svg',
  discord: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/discord.svg',
  telegram: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/telegram.svg',
  microsoftTeams: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/microsoftteams.svg',
  gmail: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/gmail.svg',
  microsoftOutlook: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/microsoftoutlook.svg',
  hubspot: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/hubspot.svg',
  salesforce: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/salesforce.svg',
  pipedrive: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/pipedrive.svg',
  jira: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/jira.svg',
  linear: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/linear.svg',
  notion: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/notion.svg',
  trello: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/trello.svg',
  asana: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/asana.svg',
  xero: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/xero.svg',
  quickbooks: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/quickbooks.svg',
  shopify: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/shopify.svg',
  wooCommerce: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/woo.svg',
  stripe: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/stripe.svg',
  postgres: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/postgresql.svg',
  mysql: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/mysql.svg',
  mongoDb: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/mongodb.svg',
  redis: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/redis.svg',
  googleSheets: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/googlesheets.svg',
  airtable: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/airtable.svg',
  s3: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/amazons3.svg',
  googleDrive: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/googledrive.svg',
  github: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/github.svg',
  gitlab: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/gitlab.svg',
  openAi: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/openai.svg',
  twilio: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/twilio.svg',
  sendGrid: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/sendgrid.svg',
  googleCalendar: 'https://cdn.jsdelivr.net/npm/simple-icons@v11/icons/googlecalendar.svg',
  ftp: null, // no logo, use core icon
};

// SVG icons for core n8n node types (rendered inline)
const CORE_ICONS = {
  webhook: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <path d="M13 10V3L4 14h7v7l9-11h-7z" />
    </svg>
  ),
  scheduleTrigger: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" />
    </svg>
  ),
  cronTrigger: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" />
    </svg>
  ),
  manualTrigger: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <path d="M18 8h1a4 4 0 010 8h-1M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8zM6 1v3M10 1v3M14 1v3" />
    </svg>
  ),
  httpRequest: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" /><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  ),
  respondToWebhook: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <path d="M9 10l-5 5 5 5" /><path d="M20 4v7a4 4 0 01-4 4H4" />
    </svg>
  ),
  if: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" />
    </svg>
  ),
  filter: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" />
    </svg>
  ),
  switch: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <path d="M16 3h5v5M4 20L21 3M21 16v5h-5M15 15l6 6M4 4l5 5" />
    </svg>
  ),
  set: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" /><line x1="9" y1="3" x2="9" y2="21" />
    </svg>
  ),
  code: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <path d="M16 18l6-6-6-6M8 6l-6 6 6 6" />
    </svg>
  ),
  merge: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <path d="M8 6l4 4 4-4M12 10v8" />
    </svg>
  ),
  splitOut: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <path d="M16 3h5v5M4 20L21 3M21 16v5h-5M15 15l6 6M4 4l5 5" />
    </svg>
  ),
  noOp: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <circle cx="12" cy="12" r="10" /><path d="M4.93 4.93l14.14 14.14" />
    </svg>
  ),
  wait: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <circle cx="12" cy="12" r="10" /><path d="M10 9v6M14 9v6" />
    </svg>
  ),
  emailSend: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  ),
  emailReadImap: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  ),
  dateTime: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  ),
  itemLists: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <line x1="8" y1="6" x2="21" y2="6" /><line x1="8" y1="12" x2="21" y2="12" /><line x1="8" y1="18" x2="21" y2="18" /><line x1="3" y1="6" x2="3.01" y2="6" /><line x1="3" y1="12" x2="3.01" y2="12" /><line x1="3" y1="18" x2="3.01" y2="18" />
    </svg>
  ),
  aggregate: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
    </svg>
  ),
  removeDuplicates: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <rect x="3" y="3" width="18" height="18" rx="2" /><path d="M9 9l6 6M15 9l-6 6" />
    </svg>
  ),
  limit: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <path d="M17 3H7a2 2 0 00-2 2v14l7-3 7 3V5a2 2 0 00-2-2z" />
    </svg>
  ),
  sort: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <path d="M11 5h10M11 9h7M11 13h4M3 17l3 3 3-3M6 18V4" />
    </svg>
  ),
  xml: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" /><path d="M14 2v6h6" /><path d="M9 15l2 2 4-4" />
    </svg>
  ),
  html: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <path d="M16 18l6-6-6-6M8 6l-6 6 6 6" />
    </svg>
  ),
  crypto: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0110 0v4" />
    </svg>
  ),
  ftp: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-full h-full">
      <path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z" />
    </svg>
  ),
};

// Inline brand SVGs for ones that don't load reliably from CDN
const INLINE_BRAND_ICONS = {
  slack: (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full"><path d="M5.042 15.165a2.528 2.528 0 0 1-2.52 2.523A2.528 2.528 0 0 1 0 15.165a2.527 2.527 0 0 1 2.522-2.52h2.52v2.52zM6.313 15.165a2.527 2.527 0 0 1 2.521-2.52 2.527 2.527 0 0 1 2.521 2.52v6.313A2.528 2.528 0 0 1 8.834 24a2.528 2.528 0 0 1-2.521-2.522v-6.313zM8.834 5.042a2.528 2.528 0 0 1-2.521-2.52A2.528 2.528 0 0 1 8.834 0a2.528 2.528 0 0 1 2.521 2.522v2.52H8.834zM8.834 6.313a2.528 2.528 0 0 1 2.521 2.521 2.528 2.528 0 0 1-2.521 2.521H2.522A2.528 2.528 0 0 1 0 8.834a2.528 2.528 0 0 1 2.522-2.521h6.312zM18.956 8.834a2.528 2.528 0 0 1 2.522-2.521A2.528 2.528 0 0 1 24 8.834a2.528 2.528 0 0 1-2.522 2.521h-2.522V8.834zM17.688 8.834a2.528 2.528 0 0 1-2.523 2.521 2.527 2.527 0 0 1-2.52-2.521V2.522A2.527 2.527 0 0 1 15.165 0a2.528 2.528 0 0 1 2.523 2.522v6.312zM15.165 18.956a2.528 2.528 0 0 1 2.523 2.522A2.528 2.528 0 0 1 15.165 24a2.527 2.527 0 0 1-2.52-2.522v-2.522h2.52zM15.165 17.688a2.527 2.527 0 0 1-2.52-2.523 2.526 2.526 0 0 1 2.52-2.52h6.313A2.527 2.527 0 0 1 24 15.165a2.528 2.528 0 0 1-2.522 2.523h-6.313z"/></svg>
  ),
  microsoftTeams: (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full"><path d="M20.625 8.5h-1.5a2.627 2.627 0 0 0 1 .563V12.5a2.12 2.12 0 0 1-2.12 2.12H15v.38a3 3 0 0 1-3 3H9.388A4.49 4.49 0 0 0 13.5 21a4.5 4.5 0 0 0 4.5-4.5v-5h2.625A1.375 1.375 0 0 0 22 10.125v-.25A1.375 1.375 0 0 0 20.625 8.5zM19 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM14.5 5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0zM15 8H9a2 2 0 0 0-2 2v5a5 5 0 0 0 10 0v-5a2 2 0 0 0-2-2z"/></svg>
  ),
  microsoftOutlook: (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full"><path d="M24 7.387v10.478c0 .23-.08.424-.238.576a.806.806 0 0 1-.59.236h-8.42v-5.768l1.2.98a.373.373 0 0 0 .482 0l6.99-5.478c.06-.037.12-.058.18-.058.09 0 .154.04.218.117.063.078.094.163.094.258zM24 5.39a.96.96 0 0 0-.078-.16c-.08-.12-.252-.18-.51-.18h-8.66v4.18l1.2.98a.373.373 0 0 0 .482 0L23.81 4.86c.12-.1.19-.2.19-.32v.85zM14.752 10.27v5.516H8.19V7.66h6.563v2.61zm-2.34-5.14H2.344C1.062 5.13 0 6.188 0 7.473v9.055c0 1.284 1.062 2.342 2.344 2.342h10.068c1.282 0 2.344-1.058 2.344-2.342V7.473c0-1.285-1.062-2.342-2.344-2.342zM7.378 15.41c-2.32 0-3.605-1.71-3.605-3.87 0-2.21 1.345-3.92 3.665-3.92 2.36 0 3.59 1.78 3.59 3.86-.001 2.34-1.42 3.93-3.65 3.93zm.04-6.67c-1.4 0-2.2 1.22-2.2 2.74 0 1.5.77 2.81 2.18 2.81 1.39 0 2.18-1.28 2.18-2.78 0-1.49-.75-2.77-2.16-2.77z"/></svg>
  ),
  salesforce: (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full"><path d="M10.006 5.17a4.012 4.012 0 0 1 2.985-1.323 4.012 4.012 0 0 1 3.755 2.57 4.669 4.669 0 0 1 1.93-.42c2.597 0 4.702 2.127 4.702 4.75 0 2.624-2.105 4.75-4.701 4.75a4.664 4.664 0 0 1-.874-.084 3.588 3.588 0 0 1-3.2 1.988 3.56 3.56 0 0 1-1.76-.465 4.084 4.084 0 0 1-3.834 2.72 4.095 4.095 0 0 1-3.95-3.082 3.903 3.903 0 0 1-.584.045C2.298 16.619 0 14.308 0 11.5c0-2.004 1.14-3.735 2.805-4.56A3.829 3.829 0 0 1 2.59 5.6a3.86 3.86 0 0 1 3.852-3.873 3.85 3.85 0 0 1 3.564 2.444z"/></svg>
  ),
  pipedrive: (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full"><path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 3.5a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 13.5c-2.33 0-4.31-1.46-5.11-3.5h10.22c-.8 2.04-2.78 3.5-5.11 3.5z"/></svg>
  ),
  sendGrid: (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full"><path d="M1.6 8h6.4v6.4H1.6V8zm6.4-6.4H14.4V8H8V1.6zM14.4 8h6.4v6.4h-6.4V8zm0 6.4h-6.4v6.4H14.4v-6.4z"/></svg>
  ),
};

const NodeIcon = ({ nodeKey: rawKey, label, size = 'sm' }) => {
  // Strip package prefix to get short key for icon lookups
  const nodeKey = (rawKey || '').includes('.') ? rawKey.split('.').pop() : rawKey;
  const sizeClasses = size === 'sm' ? 'w-4 h-4' : 'w-5 h-5';

  // Check for inline brand SVGs first (most reliable)
  if (INLINE_BRAND_ICONS[nodeKey]) {
    return <div className={`${sizeClasses} text-white`}>{INLINE_BRAND_ICONS[nodeKey]}</div>;
  }

  // Check for inline core SVG icon
  if (CORE_ICONS[nodeKey]) {
    return <div className={`${sizeClasses} text-white`}>{CORE_ICONS[nodeKey]}</div>;
  }

  // Fallback to CDN logo
  if (LOGO_URLS[nodeKey]) {
    return (
      <img
        src={LOGO_URLS[nodeKey]}
        alt={label}
        className={sizeClasses}
        style={{ filter: 'brightness(0) invert(1)' }}
        loading="lazy"
        onError={(e) => { e.target.style.display = 'none'; }}
      />
    );
  }

  // Final fallback: first letter
  return (
    <span className={`font-bold text-white text-xs`}>
      {(label || '?').charAt(0).toUpperCase()}
    </span>
  );
};

export default NodeIcon;
export { LOGO_URLS, CORE_ICONS };
